"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("../../../utils/styles");

var _ref2 = /*#__PURE__*/_react.default.createElement("rect", {
  id: "Radio-Bounds",
  fillOpacity: "0.1",
  fill: "#FF0000",
  opacity: "0",
  x: "0",
  y: "0",
  width: "18",
  height: "18"
});

var CheckedIcon = /*#__PURE__*/_react.default.memo(function (_ref) {
  var props = (0, _extends2.default)({}, _ref);
  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "18",
    height: "18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    id: "Radio-Background",
    stroke: theme.colors.secondary,
    cx: "9",
    cy: "9",
    r: "7.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    id: "Radio-Circle",
    fill: theme.colors.secondary,
    cx: "9",
    cy: "9",
    r: "4"
  }), _ref2));
});

var _default = CheckedIcon;
exports.default = _default;